import { render, staticRenderFns } from "./otherBenefitDeduction.vue?vue&type=template&id=9a8432c2&scoped=true&"
import script from "./otherBenefitDeduction.vue?vue&type=script&lang=js&"
export * from "./otherBenefitDeduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a8432c2",
  null
  
)

export default component.exports